import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import CompareViewModel from "../viewModel";

const UnitPrice = () => {
  const { t } = useTranslation();
  const { compareItems, currencySymbol, currencyRate } = useContext(
    CompareViewModel.Context
  );

  return (
    <tr>
      <th className="title-column">{t("compare.unitPrice")}</th>
      {compareItems.map((compareItem) => (
        <td className="product-price" key={compareItem._id}>
          <span className="amount">
            {currencySymbol + (compareItem.price * currencyRate).toFixed(2)}
          </span>
        </td>
      ))}
    </tr>
  );
};

export default UnitPrice;
